import React, { createRef, useEffect } from "react";
import { gsap } from "gsap";

import Whatsapp from "./../assets/icons/whatsapp.png";
import Youtube from "./../assets/icons/youtube.png";
import Telegram from "./../assets/icons/telegram.png";

const FollowBar = () => {
  const youtubeRef = createRef();
  const whatsappRef = createRef();
  const telegramRef = createRef();

  useEffect(() => {
    gsap
      .fromTo(
        youtubeRef.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.2,
        }
      )
      .delay(5);

    gsap
      .fromTo(
        whatsappRef.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.2,
        }
      )
      .delay(5.3);
    gsap
      .fromTo(
        telegramRef.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.2,
        }
      )
      .delay(5.6);
  }, []);

  const handleYoutube = () => {
    window.open("https://youtube.com/winningstar", "_blank");
  };

  const handleWhatsapp = () => {
    window.open("https://bit.ly/winningstarguessingwhatsapp", "_blank");
  };

  const handleTelegram = () => {
    window.open("https://bit.ly/winningstarguessingtelegram", "_blank");
  };

  return (
    <div className="followContainer">
      <div
        onClick={handleYoutube}
        ref={youtubeRef}
        className="followIconContainer"
      >
        <img src={Youtube} className="followIcon" />
      </div>

      <div
        onClick={handleWhatsapp}
        ref={whatsappRef}
        className="followIconContainer"
      >
        <img src={Whatsapp} className="followIcon" />
      </div>

      <div
        onClick={handleTelegram}
        ref={telegramRef}
        className="followIconContainer"
      >
        <img src={Telegram} className="followIcon" />
      </div>
    </div>
  );
};

export default FollowBar;
